<template>
    <div>
        <!-- Contenido principal -->
        <main class="layoutContent">
            <!-- Encabezado contenido principal -->
            <header class="page-header">
                <div class="container pt-2">
                    <div class="row align-items-center justify-content-between">
                        <div class="col-5 pt-1">
                            <h1 class="page-header--title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                    class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                    <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                                    <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                </svg>
                                Vacantes
                            </h1>
                            
                            <div class="form-group col">
                                <!-- <label for="adultos">Tipo Establecimiento</label> -->
                                <b-form-select v-model="plan" disabled
                                    @change="cambio_plan"
                                    :options="planes"
                                    class="mb-1 form-control"                                    
                                ></b-form-select>
                            </div>
                        </div>
                        <div class="col-5 pt-5">
                            <p class="page-header--subtitle">
                                <b-btn size="sm" class="btn btn-outline-green" @click="ver_pdf">Ver / descargar catálogo en pdf</b-btn>
                            </p>
                        </div>
                        <div class="col-12 col-xl-5 mt-2">
                            <div class="input-group input-group-joined w-100">
                                <!-- <input class="form-control" type="text" placeholder="Búsqueda directa... Introduce hotel, zona o población." aria-label="Search" autofocus="">
                                <div class="input-group-append">
                                    <span class="input-group-text"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <!-- Fin encabezado contenido principal -->

            <!-- Cuerpo contenido principal -->
            <div class="container content-body">
                <div class="row">
                    <!-- Bloque Filtros-->
                    <div class="col-xl-5">
                        <div class="card mb-2">
                            <div class="card-header">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                    class="bi bi-box" viewBox="0 0 16 16">
                                    <path
                                        d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                </svg>
                                Filtrar
                            </div>
                            <div class="card-body">
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <!-- <label>Zona o lugar</label> -->
                                            <b-form-select v-model="zona" value-field="id" text-field="name"                                                
                                                @change="filtro"
                                                :options="zonas"                            
                                                class="mb-1 form-control"                                    
                                            ></b-form-select>                                              
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <!-- <label>Tipo Establecimiento</label> -->
                                            <b-form-select v-model="tipo" value-field="id" text-field="name"
                                                @change="filtro"
                                                :options="tipos"
                                                class="mb-1 form-control"                                    
                                            ></b-form-select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div class="my-1">
                            <b-card class="mb-4">  
                                <div class="card-header border-bottom-0" >Establecimiento Seleccionado Vacantes</div>          
                                <div v-show="hotel.id>0">
                                    <div class="form-group">
                                        <!-- <label>Establecimiento</label> -->
                                        <input disabled class="form-control" type="text" v-model="hotel.hotel"/>                                        
                                    </div>   
                                    <div class="form-group">
                                        <!-- <label>Establecimiento</label> -->
                                        <input disabled class="form-control" type="text" v-model="hotel.periodo"/>                                        
                                    </div>   
                                    <div class="form-group">
                                        <!-- <label>Establecimiento</label> -->
                                        <input disabled class="form-control" type="text" v-model="hotel.tph"/>                                        
                                    </div>   
                                    <div class="text-center">
                                        <b-btn variant="primary" size="sm">
                                            Reservar</b-btn>                   
                                    </div>                                
                                </div>                                
                            </b-card>                                                
                        </div>
                    </div>                        

                    <!-- Bloque Establecimientos y Observaciones -->
                    <div class="col-xl-7 h-100">
                        <!-- <hotelInfo :hotel="hotel" :imgs="imgs"/> -->
                        <div class="my-1">
                            <b-card class="mb-4">  
                                <div class="card-header border-bottom-0">Establecimientos/Turnos</div>                                
                                <b-table striped hover sticky-header="400px"                                     
                                    selectable select-mode="single" @row-selected="selecciona"
                                    :items="turnos.items" :fields="turnos.fields"
                                    class="table-responsive-md bg-white" responsive="sm">

                                    <!-- <template slot="cell(sal)" slot-scope="{item: { sal }}">
                                        <small>{{ sal }}</small>                        
                                    </template>            
                                    
                                    <template #cell(action)="data">
                                        <b-btn size="lg" variant="light" class="p-0" v-if="data.item.lib<=1">
                                            <b-icon variant="danger" icon="x-square"></b-icon>                        
                                        </b-btn>
                                        <b-btn size="md" variant="success" class="p-1" v-else @click="selecciona(data)">
                                            <b-icon icon="cart3"></b-icon>
                                            <b-badge variant="success">{{data.item.lib}}</b-badge>                        
                                        </b-btn>                        
                                    </template> -->

                                </b-table> 
                                <!-- <p><small>Periodos </small> <b> {{turnos.items.length}} </b></p> -->
                            </b-card>                                                
                        </div>
                    </div>
                </div>                        
            </div>
            <!-- Fin Cuerpo contenido principal -->
        </main>

    </div>
</template>

<script>

// import hotelInfo from '@/components/hotel-info.vue'

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'vacantes',
  components: { 
        // hotelInfo,

  },
  data() {
    return {     
        
        zona: 0,
        zonas:[
            {value:'0', text:'(Zona/Lugar)'},
        ],
        tipo: 0,
        tipos:[
            {value:'0', text:'(Tipo)'},           
        ],
        
        hotel: {},
        imgs: false,
        itemsHot: [],

        plan: 1,
        planes:[
            {value:'1', text:'VERANO'},           
            {value:'2', text:'CAMPAMENTOS'},           
        ],

        hoteles: {
            items: [],
            fields: [
                { key:'label',label:'Establecimiento', thStyle: {display: 'none'}},
                // {key:'fhe',label:'Entrada'},                
            ],
        },

        turnos: {
            items: {},
            fields: [
                {key:'hotel',label:'Establecimiento'},
                {key:'periodo',label:'Periodo'},
                {key:'tph',label:'TipoHab'},          
                {key:'hab',label:'Hab.'},          
                {key:'pax',label:'Pax'},                          
                // {key:'action', label:''}
            ],
        },
        selected: {},
       
    }
  },

  created() {
  },

  mounted() {
    if (!this.logueado) {
        this.$router.push('/');            
        return;
    }
    this.leemos0();
  },

  computed: {
    ...mapState(['auth']),

    logueado() {
        return this.auth.logueado;
    },   
    usuario() {
        return this.$store.state.auth.user;
    },

  },

  methods: {   
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']),    

       cambio_plan() {
           //this.leemos();
           this.leemos0();

       },

       async leemos0() {
            this.loading();

            var args={ token: this.auth.token, plan: this.plan }
            let r=await this.exec({api:'vacantes', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                //this.modal({tit:"RESERVAS", msg:r.datos});
                r.datos=[];
            }                              
            //guardamos datos
            this.turnos.items=Object.values(r.datos[0]);
                                    
            this.loading(false);        

            this.selecciona0(this.turnos.items);
        },

        selecciona0(item) {
            this.selected=item[0];
        },

       async leemos() {
            this.loading();            

            this.plan=1;

            var args={ token: this.auth.token, plan: this.plan }
            let r=await this.exec({api:'hoteles', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                //this.modal({tit:"RESERVAS", msg:r.datos});
                r.datos=[];
            }                              
            //guardamos datos
            this.itemsHot=Object.values(r.datos[0]);

            this.zonas=Object.values(r.datos[1]);
            this.tipos=Object.values(r.datos[2]); console.log('leido',this.zonas);
                        
            this.loading(false);

            this.zona=0;
            this.tipo=0;
            this.filtro();
        },

        filtro() {  
            this.hotel={};            

            var H=this.itemsHot.slice();                
            var HH=H;
            //let t=this.bTxt.toLowerCase();
            let z=this.zona;
            let t=Number(this.tipo); console.log('** filtro',this.zona,this.tipo);
            console.log('**filtro1',HH,z,t)           

            /* if (t!='') HH=H.filter(e => {
                return (
                    e.exp.toLowerCase().includes(t)
                    ||e.ref.toLowerCase().includes(t)
                    ||e.contrato.toLowerCase().includes(t)                    
                    ||e.c1.toLowerCase().includes(t)
                    ||e.c2.toLowerCase().includes(t)
                );
            }) */
            
            if (t!='0'||z!='0') {
                HH=H.filter(e => { 
                    let ok=true;
                    if (t>0 && t!=Number(e.tp)) ok=false;
                    if (z>'0' && z!=e.zon) ok=false;
                    //if (t!=Number(e.tp) || z!=e.zon) ok=false;
                    return ok;
                    //return (t==Number(e.tp) && z==e.zon); 
                } );
            }
            //if (z!='0') HH=H.filter(e => { return (z==e.zon) } );
            //if (t!='0') HH=H.filter(e => { return (t==Number(e.tp)) } );
            

            console.log('**filtro2',HH,z,t)
            
            this.hoteles.items=HH;       
            //this.hotel=this.hoteles.items[0];     
            //this.selecciona(HH);

        },

        // seleccion de reserva (ver)
        selecciona(item) {      
            console.log('**selecciona1',item,typeof(item));
            Object.values(item).length;
            if (item.length==0) {
                if (this.hoteles.items.length>0) item=this.hoteles.items;
                else item[0]={id:0,name:'Hotel No Seleccionado'};
            } 
            console.log('**selecciona2',item);

            this.hotel=item[0];
            this.imgs=false;
            //this.$store.state.exped=item;   
            
            this.$store.state.hotel=this.hotel;
    
        },     
        
        ver_pdf() {
            let cc=this.planes[this.plan - 1].text.toLowerCase();
            window.open('https://fondos-sociales.com/pdf/catalogo.' + cc +'.pdf', 'blank');
        },

        

   }



    
}
</script>